import RoadMapCard from "src/component/RoadMapCard";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import RoadMapContent from "./RoadMapContent";
import RoadmapYear from "./RoadMapContent";
import { AnimationOnScroll } from "react-animation-on-scroll";
import DotComp from "src/component/DotComp";
const useStyles = makeStyles((theme) => ({
  roadmapsliderBox: {
    position: "relative",
    // left: "150px",
    // padding: "46px 0 34px 151px",
    zIndex: "999",
    "@media(max-width:1280px)": {
      left: "0px",
      padding: "46px 0 34px 51px",
    },
    [theme.breakpoints.down("md")]: {
      left: "0px",
      padding: "40px 0 30px 30px",
    },
    [theme.breakpoints.down("xs")]: {
      left: "0px",
      padding: "40px 0 30px 19px",
    },
  },

  mainroadmapBox: {
    position: "relative",
    zIndex: "9",
    padding: "50px 0",
    "& .contenHeadingBox": {
      position: "relative",
      zIndex: "9999",
    },
    "& p": {
      maxWidth: "456px",
    },
    "& .shadeImg": {
      position: "absolute",
      top: "0",
      width: "auto",
      maxWidth: "100%",
      zIndex: "-1",
      opacity: "0.5",
    },
  },

  roadborderBox1: {
    position: "relative",
    borderBottom: "4px solid rgba(255, 255, 255, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    margin: "0px 0 70px",
    [theme.breakpoints.down("sm")]: {
      margin: "32px 0 120px",
    },
    "& .dotBox": {
      width: "10px",
      height: "10px",
      borderRadius: "50px",
      backgroundColor: "#eceff1",
      // position: "absolute",
      position: "relative",
      top: "7px",
    },
    "& .dotBox1": {
      width: "50px",
      border: "2px solid #fff",
      height: "50px",
      borderRadius: "50px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // marginTop: "50px",
      position: "absolute",
      top: "-16px",
    },
  },
  roadborderBoxImg: {
    position: "relative",
    zIndex: "9999",
    "& .leftImg": {
      position: "absolute",
      right: "6%",
      bottom: "0",
      maxWidth: "100px",
      opacity: "0.5",
    },
    "& .rightImg": {
      position: "absolute",
      left: "6%",
      bottom: "0",
      maxWidth: "100px",
      opacity: "0.5",
    },
  },
}));
const roadmapdata = [
  // {
  //   head: "Quarter 1",
  //   year: "2023",
  //   // des1: "Fierex website: Complementary",
  //   des2: "White Paper launch",
  //   des3: "Launch of Fieres Blockchain",
  //   des4: "ICO platform  ",
  // },
  {
    head: "Quarter 2",
    year: "2023",
    des1: "Launch of Fieres Blockchain",
    des2: "Blockchain website",
    des3: "Exchange listing",
    // des4: "White paper launch",
    // des5: "Cross-chain bridge application",
    // des6: "Exchange listing",
  },
  {
    head: "Quarter 3",
    year: "2023",
    des1: "NFT Marketplace",
    des2: "ICO Platform",
    // des3: "Stablecoin",
  },
  {
    head: "Quarter 4",
    year: "2023",
    // des1: " Advancements in Arcade based P2E games for implementing the next stages for recently created collections of NFT ",
    des2: "Cross-chain bridge application",
    // des3: "Stablecoin",
    // des4: "Decentralised Affiliate/ Referral Marketing Platform based rewards system linked with all other applications created in the Fieres ecosystem.",
  },
  {
    head: "Quarter 1",
    year: "2024",
    des1: "DEX launch with GraphQL, token creator,staking and IDO launchpad",
    des2: "Stablecoin",
    des3: "Decentralised Affiliate/Referral Marketing Platform based rewards system linked with all other applications created in the fieres ecosystem.",
  },

  {
    head: "Quarter 2",
    year: "2024",
    des1: "Play 2 Earn Game launch (Racing and strategy-based game utilising all NFT collections) created and sold as Generattive NFTS)",
    des2: "Centralised Exchange",
    des3: "Web3 Domains and Identitiies Decentralised Wallet",
  },
  {
    head: "Quarter 3",
    year: "2024",
    des1: "Metaverse virtual store platform with over 1000 templates for businesses to sell their physical items.",
  },
  {
    head: "Quarter 4",
    year: "2024",
    des1: "Metaverse meeting/convention platform enabled wit hVR compatibility.",
  },
  {
    head: "Quarter 1",
    year: "2025",
    des1: "Metaverse Music platform",
  },
  {
    head: "Quarter 2",
    year: "2025",
    des1: "Remittance-based application utilising stablecoin created on Fieres Blockchain for easing cross-border remittances.",
  },
  {
    head: "Quarter 3",
    year: "2025",
    des1: "Tbc",
  },
  {
    head: "Quarter 4",
    year: "2025",
    des1: "Tbc",
  },
];

export default function RoadMapSlider() {
  const classes = useStyles();
  const [activeIndex, setAciveIndex] = useState(1);
  var settings = {
    // centerPadding: 5000,
    // slidesToShow: 4,
    // slidesToScroll: 1,
    // speed: 5000,
    centerPadding: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => {
      // console.log("roadmapdata.length", roadmapdata.length);
      console.log("newIndex", newIndex);
      setAciveIndex(newIndex + 1);
      // if (roadmapdata.length < newIndex) {
      //   setAciveIndex(newIndex + 1);
      // } else {
      //   setAciveIndex(newIndex);
      // }
    },

    // rows: 3,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          centerPadding: "20px",
          autoplay: false,
          beforeChange: (oldIndex, newIndex) => {
            setAciveIndex(newIndex + 1);
          },
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          centerPadding: "20px",
          autoplay: true,
          beforeChange: (oldIndex, newIndex) => {
            setAciveIndex(newIndex + 1);
          },
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: "20px",
          autoplay: true,
          beforeChange: (oldIndex, newIndex) => {
            setAciveIndex(newIndex);
          },
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          // centerMode: false,
          centerPadding: "20px",
          // autoplay: true,
          // dots: true,
          beforeChange: (oldIndex, newIndex) => {
            setAciveIndex(newIndex);
          },
        },
      },
    ],
  };

  // console.log("activeIndex---", activeIndex);
  return (
    <Box style={{ overflow: "hidden" }}>
      <Box className={classes.mainroadmapBox}>
        <Box className="pinkCircleBox"></Box>
        <img src="images/road_banner-3.png" alt="images" className="shadeImg" />
        <Container>
          <Box className="contenHeadingBox">
            <AnimationOnScroll animateIn="animate__fadeInLeft">
              <Typography variant="h3" color="primary">
                See the roadmap to fieres
              </Typography>
            </AnimationOnScroll>

            <Box mt={2}>
              <AnimationOnScroll animateIn="animate__fadeInUp">
                <Typography variant="body1" color="primary">
                  Here's the Quarterly roadmap to the Fieres.
                </Typography>
              </AnimationOnScroll>
            </Box>
          </Box>
        </Container>
      </Box>
      <Container>
        <Box className={classes.roadmapsliderBox}>
          <Slider {...settings} className="slickbottomslider">
            {roadmapdata.map((value, index) => (
              <>
                <RoadMapCard
                  value={value}
                  activeIndex={activeIndex}
                  index={index}
                  setAciveIndex={(item) => setAciveIndex(item)}
                />
              </>
            ))}
          </Slider>
        </Box>
      </Container>
      <Box className={classes.roadborderBoxImg}>
        <img src="images/borderLeft.png" alt="image" className="leftImg" />
        <img src="images/BorderRight.png" alt="image" className="rightImg" />
        <Container>
          <Box className={classes.roadborderBox1}>
            {roadmapdata.map((value, index) => (
              <DotComp value={value} activeIndex={activeIndex} index={index} />
            ))}

            {/* <DotComp
      value={value}
      activeIndex={activeIndex}
      index={index}
      setAciveIndex={(item) => setAciveIndex(item)}
    /> */}
          </Box>
        </Container>
      </Box>

      {/* <Container>
        <Box style={{ position: "relative", zIndex: "999" }}>
          <AnimationOnScroll animateIn="animate__fadeInUp">
            <RoadMapContent activeIndex={activeIndex} />
          </AnimationOnScroll>
        </Box>
      </Container> */}
    </Box>
  );
}
